export enum PayFormTypeEnum {
    CashCode = 1,
    Deferred = 2
}